var map = {
	"./Alert.svg": 97909,
	"./AlertAnnouncement.svg": 80003,
	"./ArrowCircleRight.svg": 73441,
	"./ArrowDown.svg": 20210,
	"./ArrowUp.svg": 45042,
	"./Bars.svg": 76296,
	"./Box.svg": 25468,
	"./Calendar.svg": 13739,
	"./Cart.svg": 25191,
	"./Chat.svg": 76155,
	"./CheckActive.svg": 37925,
	"./CircleIconBg.svg": 41077,
	"./Config.svg": 54193,
	"./Contact.svg": 89965,
	"./Database.svg": 9125,
	"./Dolar.svg": 3167,
	"./EmptyListCampaigns.svg": 55246,
	"./ErrorLoadingImg.svg": 50317,
	"./Export.svg": 13151,
	"./FilledBars.svg": 87984,
	"./GenericPersonaPicture.svg": 29080,
	"./InfoEmpty.svg": 12899,
	"./Logout.svg": 99090,
	"./Oto.svg": 61474,
	"./Pen.svg": 32698,
	"./Pencil.svg": 76510,
	"./Persona.svg": 89068,
	"./Recurrent.svg": 73630,
	"./RemoveOption.svg": 75735,
	"./Rename.svg": 63583,
	"./Send.svg": 75527,
	"./SendEmailTest.svg": 34638,
	"./Share.svg": 44927,
	"./ShoppingOff.svg": 25079,
	"./ShoppingOn.svg": 68821,
	"./Store.svg": 88102,
	"./StoreOmni.svg": 68209,
	"./Table.svg": 12910,
	"./Target.svg": 98907,
	"./Trash.svg": 259,
	"./Trophy.svg": 47255,
	"./Union.svg": 55652,
	"./User.svg": 13746,
	"./arrow-left.svg": 36692,
	"./arrow.svg": 16229,
	"./black-star-icon.svg": 50508,
	"./campaign-oto-static.svg": 99444,
	"./check-error.svg": 99348,
	"./check-neutral.svg": 5954,
	"./check-success.svg": 54237,
	"./clock.svg": 60579,
	"./email-campaign.svg": 26687,
	"./icons/error.svg": 20288,
	"./icons/message-preview.svg": 77436,
	"./icons/success.svg": 95300,
	"./icons/warning.svg": 2032,
	"./icons/warning_high.svg": 75997,
	"./info-circle-orange.svg": 3743,
	"./information.svg": 45137,
	"./insights/insight-bags.svg": 5449,
	"./insights/insight-card.svg": 73338,
	"./insights/insight-cart.svg": 34400,
	"./insights/insight-replenishment.svg": 54260,
	"./loader-circle.svg": 99120,
	"./login/logo-crm.svg": 16902,
	"./login/logo-oto.svg": 23678,
	"./login/oto-smile.svg": 79887,
	"./login/waves.svg": 18021,
	"./login/welcome-image.svg": 11844,
	"./menu/analytics-o2o.svg": 92138,
	"./menu/base-management.svg": 9113,
	"./menu/campaigns.svg": 71854,
	"./menu/cashback.svg": 62145,
	"./menu/data-and-integrations.svg": 64213,
	"./menu/email.svg": 87405,
	"./menu/help.svg": 62109,
	"./menu/oto-academy.svg": 24698,
	"./menu/settings.svg": 91181,
	"./menu/sms.svg": 97771,
	"./menu/store-team-management.svg": 81211,
	"./purple-star-icon.svg": 76050,
	"./question-outline.svg": 14491,
	"./red-alert-icon.svg": 88635,
	"./rocket-blue.svg": 20958,
	"./seller.svg": 40293,
	"./star.svg": 79501,
	"./white-star-icon.svg": 42199,
	"./white-start-icon.svg": 66227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84405;